export default __webpack_public_path__ + "assets/af17e39034780b8ba359ea34810ce25f.png";